import React, { useState, useEffect, useRef } from 'react';
import {
  Container,
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  InputGroup, InputGroupAddon, InputGroupText
} from 'reactstrap';
import { connect } from 'react-redux';
import VAssociationFields from './VAssociationFields';
import { IVBienCard, ITarget } from '../../../types/interfaces';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { useAlert } from "react-alert";
import ReactTooltip from 'react-tooltip';
import NumberFormat from 'react-number-format';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft, faBuilding, faHashtag, faHouseDamage, faLayerGroup, faMoneyBill, faMoneyBillAlt, faRulerCombined, faThLarge, faCompass, faMap, faQuestionCircle, faSquare, faCheckSquare, faMapMarkerAlt, faSignature, faFolder, faPercent, faFileInvoice, faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons'
import PDFLink from '../../pdf/PDFLink';
import { getVenteByIdPromise } from '../../../flux/actions/venteActions';
import { constants } from '../../../types/constants';

const VBienCard = ({ 
  selectedBien,
  setSelectedBien,
  isAssociation,
  association,
  setAssociation,
  remiseValue,
  setRemiseValue,
  remiseTotalValue,
  setRemiseTotalValue,
  prixAafficherValue,
  setPrixAafficherValue,
  prixAafficherTotalValue,
  setPrixAafficherTotalValue,
  displayTopDetails,
 }: IVBienCard) => {
  const [imageUrl, setImageUrl] = useState('');
  // const [remiseValue, setRemiseValue] = useState(0);
  // const [prixAafficherValue, setPrixAafficherValue] = useState(0);
  const [selectedFloor, setSelectedFloor] = useState<any>();
  const [selectedDivisionType, setSelectedDivisionType] = useState<any>();
  const [selectedDivisionPercent, setSelectedDivisionPercent] = useState<any>();
  const [etageValue, setEtageValue] = useState<any>('');
  const [typeValue, setTypeValue] = useState<any>('');
  const [positionValue, setPositionValue] = useState('');
  const [percentValue, setPercentValue] = useState(0);
  const [superficieValue, setSuperficieValue] = useState(0);
  const [prixpartValue, setPrixpartValue] = useState(0);
  const [partCommentValue, setPartCommentValue] = useState('');
  const [remiseFlag, setRemiseFlag] = useState(false);
  const [prixAafficherFlag, setPrixAafficherFlag] = useState(false);
  const [showRemiseM, setShowRemiseM] = useState(true);
  const [showPrixAafficherM, setShowPrixAafficherM] = useState(true);
  const [prixAafficherCanBeChanged, setPrixAafficherCanBeChanged] = useState(true);
  const [remiseLimitFlag, setRemiseLimitFlag] = useState(false);
  const [prixAafficherLimitFlag, setPrixAafficherLimitFlag] = useState(false);
  const remiseRef = useRef<HTMLInputElement>(document.createElement("input"));
  const prixAafficherRef = useRef<HTMLInputElement>(document.createElement("input"));

  const remiseChangeHandler = (e/*: ITarget*/) => {
    const doubleValue = e.target.value ? e.target.value.toString().replace(",", ".") : 0,
      splits = doubleValue.toString().split(".");
    if(!isNaN(doubleValue) && +doubleValue >= 0){
      const res = splits.length === 2 && splits[1] !== "" ? Number((+doubleValue).toFixed(2)) : doubleValue;
      setRemiseValue(res);
    }
    else if(e.target.value === "")
      setRemiseValue(0)
  };

  const prixAafficherChangeHandler = (e/*: ITarget*/) => {
    setPrixAafficherCanBeChanged(false);
    const doubleValue = e.target.value ? e.target.value.toString().replace(",", ".") : 0,
      splits = doubleValue.toString().split(".");
    if(!isNaN(doubleValue) && +doubleValue >= 0){
      const res = splits.length === 2 && splits[1] !== "" ? Number((+doubleValue).toFixed(2)) : doubleValue;
      setPrixAafficherValue(res);
    }
    else if(e.target.value === "")
      setPrixAafficherValue(0)
  };

  const prixAafficherTotalChangeHandle = (e) => {
    setPrixAafficherTotalValue(e);
    if(prixAafficherCanBeChanged)
      setPrixAafficherValue(e ? selectedBien.PRIX_VENTE : selectedBien.PRIX_M)
  }

  const focusHandler = (e) => {
    if(e.target.value == "0")
      e.target.select();
  };

  useEffect(() => {
    if(!remiseFlag)
      setRemiseFlag(true)
    else if(remiseValue === 0 && remiseRef?.current)
      remiseRef.current.select()
  }, [remiseValue]);

  useEffect(() => {
    if(!prixAafficherFlag)
      setPrixAafficherFlag(true)
    else if(prixAafficherValue === 0 && prixAafficherRef?.current)
      prixAafficherRef.current.select()
  }, [prixAafficherValue]);

  useEffect(() => {
    switch(selectedBien.TYPE_2?.toLowerCase()){
      case constants.LOT: setImageUrl("url('/images/soil.png')"); break;
      case constants.VILLA: setImageUrl("url('/images/villa.png')"); break;
      case constants.APPARTEMENT: setImageUrl("url('/images/apartment.png')"); break;
      case constants.MAGASIN: setImageUrl("url('/images/shop.png')"); break;
      case constants.EQUIPEMENT: setImageUrl("url('/images/equipment.png')"); break;
      default: setImageUrl(""); break;
    }
    if(selectedBien.TYPE_2?.toLowerCase() === "appartement"){
      setShowRemiseM(false);
      setShowPrixAafficherM(false);
      setRemiseTotalValue(true);
      setPrixAafficherTotalValue(true);
    }
    else{
      setShowRemiseM(true);
      setShowPrixAafficherM(true);
      // setRemiseTotalValue(false);
      setPrixAafficherTotalValue(false);
    }
  }, [selectedBien.TYPE_2])

  useEffect(() => {
    setRemiseValue(0);
    setPrixAafficherCanBeChanged(true);
  }, [selectedBien])

  useEffect(() => {
    if(selectedBien){
      // if(selectedBien.TYPE_2?.toLowerCase() === "appartement")
        setPrixAafficherValue(prixAafficherTotalValue ? selectedBien.PRIX_VENTE : selectedBien.PRIX_M)
    }
    else
      setPrixAafficherValue(0)
  }, [selectedBien, prixAafficherTotalValue])

  useEffect(() => {
    let invalid = true;
    if(selectedBien)
      if((prixAafficherTotalValue && prixAafficherValue >= selectedBien.PRIX_VENTE && prixAafficherValue < selectedBien.PRIX_VENTE * 10)
      || (!prixAafficherTotalValue && (!selectedBien.PRIX_M || (prixAafficherValue >= selectedBien.PRIX_M && prixAafficherValue < selectedBien.PRIX_M * 10))))
        invalid = false;
    setPrixAafficherLimitFlag(invalid)
  }, [selectedBien, prixAafficherValue, prixAafficherTotalValue])

  useEffect(() => {
    let invalid = true;
    if(selectedBien)
      if((remiseTotalValue && remiseValue < selectedBien.PRIX_VENTE)
      || (!remiseTotalValue && (!selectedBien.PRIX_M || (remiseValue < selectedBien.PRIX_M))))
        invalid = false;
    setRemiseLimitFlag(invalid)
  }, [selectedBien, remiseValue, remiseTotalValue])

  useEffect(() => {
    setAssociation({
      selectedFloor,
      selectedDivisionType,
      selectedDivisionPercent,
      ETAGE: selectedFloor?.floor,
      TYPE: typeValue ? typeValue["isNew"] ? typeValue["name"] : typeValue.value : undefined,
      POSITION: positionValue,
      POURCENTAGE: !selectedBien?.division ? percentValue : selectedDivisionPercent?.percent,
      SUPERFICIE: superficieValue,
      PRIX_VENTE: prixpartValue,
      OBSERVATION: partCommentValue,
    })
  }, [selectedFloor, selectedDivisionType, selectedDivisionPercent, typeValue, positionValue, percentValue, superficieValue, prixpartValue]);

  return (
    <div className="fadeAnimation">
      {!selectedBien?.contrat ? <Container className="CardInfo">
        <Row className="padding-0">
          <Col xs="12" md="3" className="cardImageContainer">
            <div title={selectedBien.TYPE_2 || ""} className="cardImage" style={{backgroundImage: imageUrl}}></div>
            <div className="cardImageTitle">{selectedBien.TYPE || '-'}</div>
          </Col>
          <Col xs="12" md="9" style={{border: "none"}}>
            <Row className="cardTitlesRow">
              <Col xs="12" className="border-0">
                <p className="cardTitles">Informations système</p>
              </Col>
            </Row>
            <Row>
              <Col xs="12" sm="6">
                {/* <FontAwesomeIcon icon={faHouseDamage} />&nbsp;<strong>Type : </strong>{selectedBien.TYPE || '-'} */}
                <FontAwesomeIcon icon={faMapMarkerAlt} />&nbsp;<strong>Projet : </strong>{selectedBien.PROJET || '-'}
              </Col>
              <Col xs="12" sm="6">
                <FontAwesomeIcon icon={faHashtag} />&nbsp;<strong>N° : </strong>{selectedBien.N}
              </Col>
            </Row>
            {!isAssociation && <Row>
              <Col xs="12" sm="6">
                <FontAwesomeIcon icon={faThLarge} />&nbsp;<strong>Tranche : </strong>{selectedBien.TRANCHE || "-"}
              </Col>
              <Col xs="12" sm="6">
                <FontAwesomeIcon icon={faBuilding} />&nbsp;<strong>Immeuble : </strong>{!selectedBien.IMMEUBLE && selectedBien.IMMEUBLE !== "0" ? "-" : selectedBien.IMMEUBLE}
              </Col>
            </Row>}
            {!isAssociation && <Row>
              <Col xs="12" sm="6">
                <FontAwesomeIcon icon={faLayerGroup} />&nbsp;<strong>Étage N° : </strong>{!selectedBien.ETAGE && selectedBien.ETAGE !== "0" ? "-" : selectedBien.ETAGE}
              </Col>
              <Col xs="12" sm="6">
                <FontAwesomeIcon icon={faRulerCombined} />&nbsp;<strong>Superficie : </strong>{selectedBien.TYPE_2?.toLowerCase() === "appartement" ? "-" : (selectedBien.SUPERFICIE + "m²")}
              </Col>
            </Row>}
            {isAssociation && <Row>
              <Col xs="12" sm="6">
                <FontAwesomeIcon icon={faThLarge} />&nbsp;<strong>Tranche : </strong>{selectedBien.TRANCHE || "-"}
              </Col>
              <Col xs="12" sm="6">
                <FontAwesomeIcon icon={faRulerCombined} />&nbsp;<strong>Superficie : </strong>{selectedBien.TYPE_2?.toLowerCase() === "appartement" ? "-" : (selectedBien.SUPERFICIE + "m²")}
              </Col>
            </Row>}
            {(selectedBien.ORIENTATION || selectedBien.POSITION) && <Row>
              <Col xs="12" sm="6">
                <FontAwesomeIcon icon={faCompass} />&nbsp;<strong>Orientation : </strong>{selectedBien.ORIENTATION || "-"}
              </Col>
              <Col xs="12" sm="6">
                <FontAwesomeIcon icon={faMap} />&nbsp;<strong>Position : </strong>{selectedBien.POSITION || "-"}
              </Col>
            </Row>}
            <Row>
              <Col xs="12" sm="6">
                <FontAwesomeIcon icon={faMoneyBillAlt} />&nbsp;<strong>Prix du M² : </strong>{(selectedBien.PRIX_M !== null && selectedBien.PRIX_M !== undefined && selectedBien.PRIX_M != "") ? (selectedBien.PRIX_M.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh") : "-"}
              </Col>
              <Col xs="12" sm="6">
                <FontAwesomeIcon icon={faMoneyBill} />&nbsp;<strong>Prix du bien : </strong>{(selectedBien.PRIX_VENTE !== null && selectedBien.PRIX_VENTE !== undefined && selectedBien.PRIX_VENTE != "") ? (selectedBien.PRIX_VENTE.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh") : "-"}
              </Col>
            </Row>
            <Row className="cardTitlesRow">
              <Col xs="12" className="border-0">
                <p className="cardTitles">Demandes spécifiques</p>
              </Col>
            </Row>
            <Row>
              <Col xs="12" sm="6" className="border-0">
                <FormGroup>
                  <Label for="demanderemise"><strong>Demande remise</strong></Label>
                  <span style={{display: "inline-block", whiteSpace: "nowrap"}}>
                    {showRemiseM && <span className={`bienCardRadio${!remiseTotalValue ? " selectedBCRadio" : ""}`} onClick={() => setRemiseTotalValue(false)}><FontAwesomeIcon icon={!remiseTotalValue ? faCheckSquare : faSquare} />&nbsp;du m²</span>}
                    <span className={`bienCardRadio${remiseTotalValue ? " selectedBCRadio" : ""}`} onClick={() => setRemiseTotalValue(true)}><FontAwesomeIcon icon={remiseTotalValue ? faCheckSquare : faSquare} />&nbsp;du total</span>
                  </span>
                  <InputGroup className="quantityInputGroup">
                    {/* <Input id="demanderemise" type="number" pattern="[0-9]*" invalid={remiseLimitFlag} placeholder="Remise..." innerRef={remiseRef} value={Number(remiseValue).toString()} onFocus={focusHandler} onChange={remiseChangeHandler} className="form-control" /> */}
                    <NumberFormat customInput={Input} thousandSeparator={' '} allowNegative={false} id="demanderemise" pattern="[0-9]*" invalid={remiseLimitFlag} placeholder="Remise..." innerRef={remiseRef} value={remiseValue} defaultValue={0} decimalScale={2} onFocus={focusHandler} onValueChange={e => setRemiseValue(e.value ? +e.value : 0)}/* onChange={remiseChangeHandler}*/ className="form-control" />
                    <InputGroupAddon addonType="append">
                      <InputGroupText>DH</InputGroupText>
                    </InputGroupAddon>
                  </InputGroup>
                  {/* <Input id="demanderemise" placeholder="Remise..." value={remiseValue} onChange={remiseChangeHandler} /> */}
                </FormGroup>
              </Col>
              <Col xs="12" sm="6" className="border-0">
                <FormGroup>
                  <Label for="prixaafficher"><strong>Prix comm. au client</strong>&nbsp;</Label>
                  <FontAwesomeIcon icon={faQuestionCircle} style={{cursor: "pointer"}} data-tip data-for="prixaaffichertooltip" />
                  <ReactTooltip effect="solid" id="prixaaffichertooltip" type={"dark"}>
                    Prix communiqué au client, qui peut être plus cher que le prix réel. (sans remise)
                  </ReactTooltip>
                  <span style={{display: "inline-block", whiteSpace: "nowrap"}}>
                    {showPrixAafficherM && <span className={`bienCardRadio${!prixAafficherTotalValue ? " selectedBCRadio" : ""}`} onClick={() => prixAafficherTotalChangeHandle(false)}><FontAwesomeIcon icon={!prixAafficherTotalValue ? faCheckSquare : faSquare} />&nbsp;du m²</span>}
                    <span className={`bienCardRadio${prixAafficherTotalValue ? " selectedBCRadio" : ""}`} onClick={() => prixAafficherTotalChangeHandle(true)}><FontAwesomeIcon icon={prixAafficherTotalValue ? faCheckSquare : faSquare} />&nbsp;du total</span>
                  </span>
                  {/* <Label for="prixaafficher">
                    <strong>Prix communiqué au client</strong>&nbsp;
                    <FontAwesomeIcon icon={faQuestionCircle} style={{cursor: "pointer"}} data-tip data-for="prixaaffichertooltip" />
                    <ReactTooltip effect="solid" id="prixaaffichertooltip" type={"dark"}>
                      Prix convenu avec le client, qui peut être plus cher que le prix réel.
                    </ReactTooltip>
                  </Label> */}
                  <InputGroup className="quantityInputGroup">
                    {/* <Input id="prixaafficher" type="number" pattern="[0-9]*" invalid={prixAafficherLimitFlag} placeholder="Prix communiqué au client..." innerRef={prixAafficherRef} value={Number(prixAafficherValue).toString()} onFocus={focusHandler} onChange={prixAafficherChangeHandler} className="form-control" /> */}
                    <NumberFormat customInput={Input} thousandSeparator={' '} allowNegative={false} id="prixaafficher" pattern="[0-9]*" invalid={prixAafficherLimitFlag} disabled={!selectedBien.PRIX_VENTE} placeholder="Prix communiqué au client..." innerRef={prixAafficherRef} value={prixAafficherValue} defaultValue={0} decimalScale={2} onFocus={focusHandler} onValueChange={e => setPrixAafficherValue(e.value ? +e.value : 0)}/* onChange={prixAafficherChangeHandler}*/ className="form-control" />
                    <InputGroupAddon addonType="append">
                      <InputGroupText>DH</InputGroupText>
                    </InputGroupAddon>
                  </InputGroup>
                  {/* <Input id="prixaafficher" placeholder="Prix m² à afficher..." value={prixAafficherValue} onChange={prixAafficherChangeHandler} /> */}
                </FormGroup>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container> : <Container className="CardInfo fadeAnimation">
        <Row className="padding-0">
          <Col xs="12" md="3" className="cardImageContainer">
            <div title={selectedBien.TYPE_2 || ""} className="cardImage" style={{backgroundImage: imageUrl}}></div>
            <div className="cardImageTitle">{selectedBien.contrat.TYPE || '-'}</div>
          </Col>
          <Col xs="12" md="9" style={{border: "none"}}>
            {!!displayTopDetails && <Row className="justify-content-end" style={{padding: 0}}>
              <PDFLink documentType={"vente"}
                func={async () => getVenteByIdPromise(selectedBien.contrat?.id || -1)}
                download={false}
                buttonContent=" Fiche de vente"
                customClassNames="desistementTopBtns"
                // customClassNames="btn btn-success linesConfirmationBtn linesDeleteBtn pl-3 pr-3 mb-2"
                customButtonIcon={faFileInvoice}
                iconSize="inherit"
                allowPrintPreview={true} />
              <button className="desistementTopBtns" title={`Ouvrir la consulation ID ${selectedBien.contrat?.id}`} onClick={() => window.open('/consultation/' + selectedBien.contrat?.id, '_blank')}>
                <FontAwesomeIcon icon={faExternalLinkAlt} />&nbsp;Plus de détails
              </button>
            </Row>}
            <Row>
              <Col xs="12" sm="6">
                <FontAwesomeIcon icon={faSignature} />&nbsp;<strong>ID Bien : </strong>{selectedBien.contrat.ID_BIEN}
              </Col>
              <Col xs="12" sm="6">
                <FontAwesomeIcon icon={faFolder} />&nbsp;<strong>Dossier N° : </strong>{selectedBien.contrat.NUM_DOSS}
              </Col>
            </Row>
            <Row>
              <Col xs="12" sm="6">
                <FontAwesomeIcon icon={faMapMarkerAlt} />&nbsp;<strong>Projet : </strong>{selectedBien.contrat.PROJET || '-'}
                {/* <FontAwesomeIcon icon={faHouseDamage} />&nbsp;<strong>Type : </strong>{selectedBien.contrat.TYPE || '-'} */}
              </Col>
              <Col xs="12" sm="6">
                <FontAwesomeIcon icon={faHashtag} />&nbsp;<strong>N° : </strong>{selectedBien.contrat.N}
              </Col>
            </Row>
            {!isAssociation && <Row>
              <Col xs="12" sm="6">
                <FontAwesomeIcon icon={faThLarge} />&nbsp;<strong>Tranche : </strong>{selectedBien.contrat.TRANCHE || "-"}
              </Col>
              <Col xs="12" sm="6">
                <FontAwesomeIcon icon={faBuilding} />&nbsp;<strong>Immeuble : </strong>{!selectedBien.contrat.IMMEUBLE && selectedBien.contrat.IMMEUBLE !== "0" ? "-" : selectedBien.contrat.IMMEUBLE}
              </Col>
            </Row>}
            {!isAssociation && <Row>
              <Col xs="12" sm="6">
                <FontAwesomeIcon icon={faLayerGroup} />&nbsp;<strong>Étage N° : </strong>{!selectedBien.contrat.ETAGE && selectedBien.contrat.ETAGE !== "0" ? "-" : selectedBien.contrat.ETAGE}
              </Col>
              <Col xs="12" sm="6">
                <FontAwesomeIcon icon={faRulerCombined} />&nbsp;<strong>Superficie : </strong>{selectedBien.contrat.TYPE_2?.toLowerCase() === "appartement" ? "-" : (selectedBien.contrat.SUPERFICIE + "m²")}
              </Col>
            </Row>}
            {isAssociation && <Row>
              <Col xs="12" sm="6">
                <FontAwesomeIcon icon={faThLarge} />&nbsp;<strong>Tranche : </strong>{selectedBien.contrat.TRANCHE || "-"}
              </Col>
              <Col xs="12" sm="6">
                <FontAwesomeIcon icon={faRulerCombined} />&nbsp;<strong>Superficie : </strong>{selectedBien.contrat.TYPE_2?.toLowerCase() === "appartement" ? "-" : (selectedBien.contrat.SUPERFICIE + "m²")}
              </Col>
            </Row>}
            {(selectedBien.contrat.ORIENTATION || selectedBien.contrat.POSITION) && <Row>
              <Col xs="12" sm="6">
                <FontAwesomeIcon icon={faCompass} />&nbsp;<strong>Orientation : </strong>{selectedBien.contrat.ORIENTATION || "-"}
              </Col>
              <Col xs="12" sm="6">
                <FontAwesomeIcon icon={faMap} />&nbsp;<strong>Position : </strong>{selectedBien.contrat.POSITION || "-"}
              </Col>
            </Row>}
            {selectedBien.contrat.REMISE || selectedBien.contrat.PRIX_M_CLIENT ? <Row>
              <Col xs="12" sm="6">
                <FontAwesomeIcon icon={faPercent} />&nbsp;<strong>Remise : </strong>{(selectedBien.contrat.REMISE !== null && selectedBien.contrat.REMISE !== undefined) ? (<div style={{display: "inline-block", ...(selectedBien.contrat.REMISE > 0 ? selectedBien.contrat.REMISE_VALIDEE === -1 ? {color: "orangered"} : selectedBien.contrat.REMISE_VALIDEE === 0 ? {color: "red"} : {} : {})}}>
                  {selectedBien.contrat.REMISE.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}&nbsp;Dh{selectedBien.contrat.REMISE > 0 ? " (du total)" : ""}&nbsp;
                  {selectedBien.contrat.REMISE > 0 && (selectedBien.contrat.REMISE_VALIDEE === -1 || selectedBien.contrat.REMISE_VALIDEE === 0) ? <div style={{display: "inline-block"}}>
                    <FontAwesomeIcon icon={faQuestionCircle} style={{cursor: "pointer"}} data-tip data-for="remise_tooltip" />
                    <ReactTooltip effect="solid" id="remise_tooltip" type={"dark"}>
                      {selectedBien.contrat.REMISE_VALIDEE === -1 ? "Demande de remise pas encore validée par l'administration" : selectedBien.contrat.REMISE_VALIDEE === 0 ? "Demande de remise refusée par l'administration" : ""}
                    </ReactTooltip>
                  </div> : null}
                </div>) : "-"}
              </Col>
              <Col xs="12" sm="6">
                <FontAwesomeIcon icon={faMoneyBill} />&nbsp;<strong>Prix comm. Client : </strong>{(selectedBien.contrat.PRIX_M_CLIENT !== null && selectedBien.contrat.PRIX_M_CLIENT !== undefined) ? (selectedBien.contrat.PRIX_M_CLIENT.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh (du total)") : "-"}
              </Col>
            </Row> : null}
            <Row>
              <Col xs="12" sm="6">
                <FontAwesomeIcon icon={faMoneyBillAlt} />&nbsp;<strong>Prix Net du M² : </strong>{(selectedBien.contrat.PRIX_M !== null && selectedBien.contrat.PRIX_M !== undefined) ? (selectedBien.contrat.PRIX_M.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh") : "-"}
              </Col>
              <Col xs="12" sm="6">
                <FontAwesomeIcon icon={faMoneyBill} />&nbsp;<strong>Prix Net : </strong>{(selectedBien.contrat.PRIX_NET !== null && selectedBien.contrat.PRIX_NET !== undefined) ? (selectedBien.contrat.PRIX_NET.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh") : "-"}
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>}
      <div className="chooseAnother">
        <p onClick={() => setSelectedBien(null)}><FontAwesomeIcon icon={faArrowLeft} />&nbsp;&nbsp;Choisir un autre bien</p>
      </div>
      {isAssociation && <VAssociationFields selectedBien={selectedBien} selectedFloor={selectedFloor} setSelectedFloor={setSelectedFloor} selectedDivisionType={selectedDivisionType} setSelectedDivisionType={setSelectedDivisionType} selectedDivisionPercent={selectedDivisionPercent} setSelectedDivisionPercent={setSelectedDivisionPercent} etageValue={etageValue} setEtageValue={setEtageValue} typeValue={typeValue} setTypeValue={setTypeValue} positionValue={positionValue} setPositionValue={setPositionValue} percentValue={percentValue} setPercentValue={setPercentValue} superficieValue={superficieValue} setSuperficieValue={setSuperficieValue} prixpartValue={prixpartValue} setPrixpartValue={setPrixpartValue} commentValue={partCommentValue} setCommentValue={setPartCommentValue} />}
    </div>
  );
};

export default connect(null, {  })(VBienCard);
